// extracted by css-extract-rspack-plugin
export default {"pinchZoomContainer":"_187cd889","zoomImageWrapper":"_60569ec6","zoomImage":"_4bdb12b5","zoomOut":"_6fd8b7fc","zoomOutIcon":"_9498d877"};